import * as yup from 'yup';

export const validationSchema = yup.object({
  action: yup.string().required('Action is required.'),
});
